
import { Payload } from "@/types/profile";

export const accountsPayloads: Payload[] = [
  // Apple ID payloads
  {
    id: "apple-id",
    name: "Apple ID",
    description: "Configure Apple ID settings",
    category: "Accounts",
    supportedPlatforms: ["macos", "ios", "ipados"],
    configFields: [
      {
        id: "preventAppleIDSettings",
        name: "Prevent Apple ID Settings Modification",
        type: "boolean",
        required: true,
        default: false,
        description: "Prevents the device from accessing Apple ID settings"
      },
      {
        id: "allowAppleIDSignIn",
        name: "Allow Apple ID Sign In",
        type: "boolean",
        required: true,
        default: true,
        description: "Controls whether users can sign in with their Apple ID"
      }
    ]
  },
  
  // Active Directory payloads
  {
    id: "active-directory",
    name: "Active Directory",
    description: "Configure Active Directory settings",
    category: "Accounts",
    supportedPlatforms: ["macos"],
    configFields: [
      {
        id: "hostname",
        name: "Hostname",
        type: "text",
        required: true,
        description: "Active Directory server hostname"
      },
      {
        id: "domain",
        name: "Domain",
        type: "text",
        required: true,
        description: "Active Directory domain"
      },
      {
        id: "username",
        name: "Admin Username",
        type: "text",
        required: true,
        description: "Admin username with join privileges"
      },
      {
        id: "password",
        name: "Admin Password",
        type: "text",
        required: true,
        description: "Admin password"
      }
    ]
  },
  
  // Email payloads
  {
    id: "email",
    name: "Email",
    description: "Configure email account settings",
    category: "Accounts",
    supportedPlatforms: ["macos", "ios", "ipados"],
    configFields: [
      {
        id: "emailAddress",
        name: "Email Address",
        type: "text",
        required: true,
        description: "User's email address"
      },
      {
        id: "incomingServer",
        name: "Incoming Mail Server",
        type: "text",
        required: true,
        description: "Incoming mail server address"
      },
      {
        id: "outgoingServer",
        name: "Outgoing Mail Server",
        type: "text",
        required: true,
        description: "Outgoing mail server address"
      }
    ]
  },
  
  // LDAP payloads
  {
    id: "ldap",
    name: "LDAP",
    description: "Configure LDAP settings",
    category: "Accounts",
    supportedPlatforms: ["macos", "ios", "ipados"],
    configFields: [
      {
        id: "ldapServer",
        name: "LDAP Server",
        type: "text",
        required: true,
        description: "LDAP server address"
      },
      {
        id: "ldapPort",
        name: "LDAP Port",
        type: "number",
        required: true,
        default: 389,
        description: "LDAP server port"
      },
      {
        id: "useLDAPS",
        name: "Use LDAPS",
        type: "boolean",
        required: false,
        default: false,
        description: "Use LDAP over SSL"
      }
    ]
  },
  
  // Subscribed Calendars payloads
  {
    id: "subscribed-calendars",
    name: "Subscribed Calendars",
    description: "Configure subscribed calendars",
    category: "Accounts",
    supportedPlatforms: ["macos", "ios", "ipados"],
    configFields: [
      {
        id: "calendarURL",
        name: "Calendar URL",
        type: "text",
        required: true,
        description: "URL of the calendar to subscribe to"
      },
      {
        id: "calendarName",
        name: "Calendar Name",
        type: "text",
        required: true,
        description: "Display name for the calendar"
      },
      {
        id: "calendarDescription",
        name: "Calendar Description",
        type: "text",
        required: false,
        description: "Description of the calendar"
      }
    ]
  }
];
